export const MAX_IMAGES = 5
export const HEIGHT = 261
export const MOSAIC_FIRST_ROW_ID = 'MosaicGalleryFirstRow'
